/** zh-CN catalogue `audio` (W3-09; English: src/audio/audio.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'audio',
  locale: 'zh-CN',
  messages: {
    unsupported: '此浏览器无法播放音频。',
    decodeFailed: '无法解码此音频文件。请将其转换为 MP3、OGG 或 WAV 后重试。',
    calibrationCancelled: '已取消延迟校准。',
    calibrationNoTaps: '检测到的敲击次数太少。请跟着每一声节拍敲击一次，然后重试。',
    calibrationInconsistent: '敲击与节拍声不够稳定，无法测量延迟。请跟着每一声节拍敲击一次并保持均匀，然后重试。',
    disposed: '音频引擎已关闭。',
    superseded: '此音频文件尚未加载完成，已被更新的音频文件替换。',
  },
};

export default catalog;
